export const BACKEND_URL = "https://farminsight-backend.etce.isse.tu-clausthal.de";
